/**
 * Breadcrumb Collection Context
 * -----------------------------
 * SEO-safe workaround for product breadcrumbs showing "Home > All > Product"
 * when the visitor arrived from a collection page. Because internal product
 * links use the canonical /products/<handle> URL (no /collections/<handle>/
 * prefix, per the SEO team's directive), the Liquid `collection` variable is
 * empty on the product page and the theme falls back to "All".
 *
 * This script only changes the rendered DOM after load:
 *   - On a collection page: stores handle + title in sessionStorage.
 *   - On a product page: if a stored collection exists, rewrites the 2nd
 *     breadcrumb <li> to point at that collection.
 *
 * Canonical URLs, internal product links, and BreadcrumbList JSON-LD are
 * untouched.
 */
(function () {
  var STORAGE_KEY = 'pxu:lastCollection';
  var MAX_AGE_MS = 30 * 60 * 1000;
  var READY_CLASS = 'pxu-breadcrumb-ready';

  function safeGet() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.handle || !data.title || !data.url) return null;
      if (!data.ts || Date.now() - data.ts > MAX_AGE_MS) return null;
      return data;
    } catch (_) {
      return null;
    }
  }

  function safeSet(data) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (_) {}
  }

  // Returns collection handle if pathname is a collection page (and NOT a
  // collection-scoped product URL). Returns null otherwise.
  function collectionHandleFromPath(pathname) {
    var m = pathname.match(/^\/collections\/([^\/\?#]+)(?:\/([^\/\?#]+))?/);
    if (!m) return null;
    if (m[2] === 'products') return null;
    return m[1];
  }

  function readCollectionTitle() {
    var selectors = [
      '.collection__title',
      '.section-header__title',
      '.collection-hero__title',
      '.collection-title',
      '[data-collection-main] h1',
      'main h1',
      'h1',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.textContent) {
        var t = el.textContent.replace(/\s+/g, ' ').trim();
        if (t) return t;
      }
    }
    var dt = (document.title || '').split(' - ')[0].split(' | ')[0];
    return dt.trim();
  }

  function prettifyHandle(handle) {
    return handle
      .split('-')
      .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
      .join(' ');
  }

  function rewriteBreadcrumb(stored) {
    var navs = document.querySelectorAll('nav.breadcrumb');
    navs.forEach(function (nav) {
      var items = nav.querySelectorAll(':scope > ul > li');
      if (items.length < 2) return;
      var li = items[1];
      var separator = li.querySelector('.breadcrumb-separator');
      var anchor = document.createElement('a');
      anchor.setAttribute('href', stored.url);
      anchor.setAttribute('title', stored.title);
      anchor.textContent = stored.title;
      li.innerHTML = '';
      if (separator) li.appendChild(separator);
      li.appendChild(anchor);
    });
  }

  function markReady() {
    document.documentElement.classList.add(READY_CLASS);
  }

  function onProductPage() {
    var stored = safeGet();
    if (!stored) { markReady(); return; }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        rewriteBreadcrumb(stored);
        markReady();
      });
    } else {
      rewriteBreadcrumb(stored);
      markReady();
    }
  }

  function onCollectionPage(handle) {
    function capture() {
      var title = readCollectionTitle() || prettifyHandle(handle);
      safeSet({
        handle: handle,
        title: title,
        url: '/collections/' + handle,
        ts: Date.now(),
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', capture);
    } else {
      capture();
    }
  }

  var path = window.location.pathname;
  var collectionHandle = collectionHandleFromPath(path);

  if (collectionHandle) {
    onCollectionPage(collectionHandle);
  } else if (/\/products\//.test(path)) {
    onProductPage();
  }
})();
